import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: 'no-label-no-margin',
    templateUrl: './no-label-no-margin.component.html',
})
export class NoLabelNoMarginWrapperComponent extends FieldWrapper {
}
